export default "__VITE_ASSET__hxNfv2VD__"